import React, { useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { EditCandidateDetails, GetCandidate } from '../services/httpServices';

import CandidateEducationInfo from './EducationInfo';
import CandidateExperienceInfo from './ExperienceInfo';

const EditCandidate = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [gender, setGender] = useState('Male');
  const [maritalStatus, setMaritalStatus] = useState('Single');
  const [candidate, setCandidate] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedIdentityType, setSelectedIdentityType] = useState(null);
  const [selectedRecruitmentMethod, setSelectedRecruitmentMethod] = useState(null);

  const firstNameRef = useRef('');
  const lastNameRef = useRef('');
  const dateOfBirthRef = useRef('');
  const emailAddressRef = useRef('');
  const addressRef = useRef('');
  const identityExpiryRef = useRef('');
  const phoneNumberRef = useRef('');
  const referenceOneRef = useRef('');
  const referenceTwoRef = useRef('');
  const referenceThreeRef = useRef('');
  const fatherNmaeRef = useRef('');
  const identityRef = useRef('');
  const referedByRef = useRef('');
  const bloodGroupRef = useRef('');
  const fetch = async (event) => {
    const savedCandidate = await GetCandidate(id);

    setCandidate(savedCandidate);
    setGender(savedCandidate?.gender);
    setMaritalStatus(savedCandidate?.maritalStatus);
    setSelectedRecruitmentMethod(recruitMethods.find((e) => e.value == savedCandidate?.rectruitmentMethod));
    setSelectedIdentityType(idTypes.find((e) => e.value == savedCandidate?.identityType));
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);
  // #endregion Refs

  const handleChangeGender = (event) => {
    setGender(event.target.value);
  };
  const handleChangeMaritalStatus = (event) => {
    setMaritalStatus(event.target.value);
  };
  const SaveUser = async (event) => {
    event.preventDefault();

    const payload = {
      id: id,
      gender: gender,
      maritalStatus: maritalStatus,
      firstName: firstNameRef.current.value,
      lastName: lastNameRef.current.value,
      email: emailAddressRef.current.value,
      contact: phoneNumberRef.current.value,
      address: addressRef.current.value,
      fatherName: fatherNmaeRef.current.value,
      identityNumber: identityRef.current.value,
      identityType: selectedIdentityType?.value,
      rectruitmentMethod: selectedRecruitmentMethod?.value,
      reference1: referenceOneRef.current.value,
      reference2: referenceTwoRef.current.value,
      reference3: referenceThreeRef.current.value,
      dateOfBirth: dateOfBirthRef.current.value?.split('T')[0],
      identityExpiry: identityExpiryRef.current.value?.split('T')[0],
      bloodGroup: bloodGroupRef.current.value,
      refferedBy: referedByRef.current.value,
    };

    let response = await EditCandidateDetails(payload);

    if (response.status == 200) {
      props.setMessage('Candidate has been saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
  };

  const idTypes = [{ value: 'Identity Card' }, { value: 'Passport' }];
  const recruitMethods = [{ value: 'Social Media' }, { value: 'Company Website' }];
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="First Name"
                      required
                      variant="outlined"
                      fullWidth
                      defaultValue={candidate?.firstName}
                      size="small"
                      inputRef={firstNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Last Name"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.lastName}
                      inputRef={lastNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Email Address"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.email}
                      inputRef={emailAddressRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Contact"
                      variant="outlined"
                      fullWidth
                      required
                      size="small"
                      defaultValue={candidate?.contact}
                      inputRef={phoneNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      label="Date of Birth"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type="date"
                      defaultValue={candidate?.dateOfBirth?.split('T')[0]}
                      InputLabelProps={{ shrink: true }}
                      inputRef={dateOfBirthRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={9}>
                    <TextField
                      label="Address"
                      defaultValue={candidate?.address}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={addressRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Father's Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.fatherName}
                      inputRef={fatherNmaeRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Identity Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.identityNumber}
                      inputRef={identityRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <Autocomplete
                      id="identityType"
                      size="small"
                      options={idTypes}
                      defaultValue={idTypes.find((e) => e.value == candidate?.identityType)}
                      getOptionLabel={(source) => source.value}
                      renderInput={(params) => <TextField {...params} label="Identity Type" variant="outlined" />}
                      onChange={(event, identityType) => setSelectedIdentityType(identityType)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <Autocomplete
                      id="idType"
                      size="small"
                      options={recruitMethods}
                      defaultValue={recruitMethods.find((e) => e.value == candidate?.rectruitmentMethod)}
                      getOptionLabel={(source) => source.value}
                      renderInput={(params) => <TextField {...params} label="Recruitment Method" variant="outlined" />}
                      onChange={(event, source) => setSelectedRecruitmentMethod(source)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Identity Expiry Date"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type="date"
                      defaultValue={candidate?.identityExpiry?.split('T')[0]}
                      InputLabelProps={{ shrink: true }}
                      inputRef={identityExpiryRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Blood Group"
                      defaultValue={candidate?.bloodGroup}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={bloodGroupRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Referred  By"
                      defaultValue={candidate?.refferedBy}
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={referedByRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Reference 1"
                      variant="outlined"
                      fullWidth
                      defaultValue={candidate?.reference1}
                      size="small"
                      inputRef={referenceOneRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Reference 2"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.reference2}
                      inputRef={referenceTwoRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} hidden>
                    <TextField
                      label="Reference 3"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={candidate?.reference3}
                      inputRef={referenceThreeRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Gender:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        onChange={handleChangeGender}
                        value={gender}
                        row
                      >
                        <FormControlLabel value="Male" control={<Radio />} label="Male" />
                        <FormControlLabel value="Female" control={<Radio />} label="Female" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Marital Status:</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        onChange={handleChangeMaritalStatus}
                        value={maritalStatus}
                        row
                      >
                        <FormControlLabel value="Married" control={<Radio />} label="Married" />
                        <FormControlLabel value="Single" control={<Radio />} label="Single" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>

      <CandidateEducationInfo
        setMessage={props.setMessage}
        setLoading={props.setLoading}
        setSaved={props.setSaved}
        setOpen={props.setOpen}
      />

      <CandidateExperienceInfo
        setMessage={props.setMessage}
        setLoading={props.setLoading}
        setSaved={props.setSaved}
        setOpen={props.setOpen}
      />
    </>
  );
};

export default EditCandidate;
